import React from "react";
export default function Header() {
  return (
    <header className="py-4 px-6 bg-indigo-900 text-white">
      <div className="container mx-auto flex justify-between items-center">
        ProAstrologyReport
      </div>
    </header>
  );
}
